
import { getTeamMembers } from '~/graphql/queries.graphql'

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    members: [],
  }),

  async fetch() {
    const { entries } = await this.$graphql.cms.request(getTeamMembers)

    this.members = entries.data
  },
}
